import { useArticleModeration } from '@/features/moderation/useArticleModeration'
import { ReviewLockPlaque } from '@/features/editor/components/studio/ReviewLockNotice'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/**
 * Плашка над формой, пока проверка статьи `pending`: форма и действия заморожены
 * (`useIsArticleFrozen`), и автору нужно одно место, где сказано, почему. Отзыв заявки —
 * только у неопубликованной статьи: у живой он снял бы её с публикации.
 */
export const ArticleReviewLockNotice = ({ articleId }: { articleId: number | null }) => {
  const { state } = useArticleModeration(articleId)
  const m = useMessages(messages)
  if (state?.review?.status !== 'pending') return null
  return (
    <ReviewLockPlaque
      text={state.visibility === 'unpublished' ? m.lockNoticeUnpublished : m.lockNotice}
    />
  )
}
